import { Outlet } from 'react-router-dom';
import styles from './Layout.module.scss';


export const Layout = () => {


  return (
    <div className={styles.wrapper}>
      <main className={styles.content}>
        <Outlet />
      </main>
    </div>
  );
};
